import { NgModule } from '@angular/core';
import { AppButtonComponent } from './app-button/app-button.component';

@NgModule({
    declarations: [AppButtonComponent],
    exports: [AppButtonComponent],
})
export class AppButtonModule {}
